import { Link, useParams } from "react-router-dom";
import { sharedPlan, sharedPlanList } from "@/lib/memberPlans";
import { useCore } from "../useCore";
import { ConnectionError } from "../components/ConnectionError";
import { Loading, EmptyState, Unavailable } from "../components/kit";
import { V3Title, V3Columns, V3Actions, DetailList, DetailRow, V3_PRIMARY, V3_SECONDARY } from "../components/v3";
import { AreaCard, ResponsibleCard } from "../components/v3app";
import { CHECKLIST } from "@/lib/v3Plans";
import { CheckList, CheckRow } from "../components/v3plans";

export function SharedPlans() {
  const res = useCore("/member/plans/shared/list", sharedPlanList);
  return <div data-testid="shared-plans-page">
    <V3Title title="Mit mir geteilte Anreisepläne" intro="Hier erscheinen nur Pläne, für die dich ein bestätigter Kontakt gezielt ausgewählt hat." />
    {res.error === "notfound" ? <Unavailable testid="shared-plans-unavailable">Geteilte Anreisepläne sind in dieser Umgebung noch nicht verfügbar.</Unavailable>
      : res.error ? <ConnectionError onRetry={res.reload} /> : !res.data ? <Loading />
        : res.data.length === 0 ? <EmptyState title="Keine geteilten Anreisepläne" text="Ein Kontakt kann dich beim Planen gezielt auswählen." testid="shared-plans-empty" />
          : <DetailList>{res.data.map((p) => <DetailRow key={`${p.ownerId}:${p.activityId}`} label={p.ownerName} value={p.title}
            to={`/plaene/${p.activityId}/geteilt/${p.ownerId}`} testid={`shared-plan-${p.ownerId}-${p.activityId}`} />)}</DetailList>}
    <V3Actions><Link to="/plaene" className={V3_SECONDARY}>Zu meinen Plänen</Link></V3Actions>
  </div>;
}

export function SharedPlanDetail() {
  const { id, owner } = useParams();
  const res = useCore(`/member/plans/${encodeURIComponent(id)}/shared/${encodeURIComponent(owner)}`, (d) => {
    const p = sharedPlan(d);
    if (p.activityId !== id || p.ownerId !== owner) throw new Error("Mismatched shared plan");
    return p;
  });
  const p = res.data;
  const ended = res.error === "notfound" || res.error === "gone";
  return <div data-testid="shared-plan-detail">
    <V3Title title="Geteilter Anreiseplan" intro="Die Freigabe wird beim Laden erneut geprüft. Ein Kontakt oder eine gemeinsame Aktivität allein gibt keine Planangaben frei." />
    {ended ? <Unavailable testid="shared-plan-ended">Dieser Anreiseplan ist nicht (mehr) für dich verfügbar.</Unavailable>
      : res.error ? <ConnectionError onRetry={res.reload} /> : !p ? <Loading />
        : <V3Columns layout="detail" aside={<><AreaCard text={`${p.ownerName} · ${p.title}`} /><ResponsibleCard /></>} main={<>
          <DetailList>
            <DetailRow label="Treffen" value={p.title} testid="shared-plan-title" />
            <DetailRow label="Geteilt von" value={p.ownerName} />
            <DetailRow label="Öffentlicher Treffpunkt" value={p.travel.meeting_point_public} testid="shared-plan-meeting" />
            <DetailRow label="Planzeit" value={`${p.travel.meet_time} Uhr`} />
            <DetailRow label="Rückweg" value={p.travel.return_note || "Keine Angabe"} />
          </DetailList>
          {p.checklist ? <div className="mt-[16px]"><CheckList label="Mit dir geteilte Checkliste">
            {CHECKLIST.map(([key, title]) => <CheckRow key={key} title={title} checked={p.checklist.items.find((i) => i.key === key).done}
              value={p.checklist.items.find((i) => i.key === key).done ? "Erledigt" : "Noch offen"} testid={`shared-check-${key}`} />)}
          </CheckList></div> : <p className="mt-[12px] text-[14px] text-v3-muted" data-testid="shared-checklist-private">Eine persönliche Checkliste ist nicht für dich freigegeben.</p>}
          <V3Actions><button type="button" onClick={res.reload} className={V3_PRIMARY} data-testid="shared-plan-recheck">Freigabe erneut prüfen</button></V3Actions>
        </>} />}
    <V3Actions><Link to="/plaene/geteilt" className={V3_SECONDARY}>Zu den geteilten Anreiseplänen</Link></V3Actions>
  </div>;
}
